import React, { useState, useEffect } from 'react';
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav, Space, Input, Select } from "react-bootstrap";
import { message } from "antd";
import { oneKlicks } from "../../SDK/oneclick";
import ImageShow from '../../Uitiles/ImageShow';
import { OneKlicksFileSDK } from '../../SDK/OneKlicksFileSDK';
import { toast } from 'react-toastify';
import formatDoctorName from '../../Uitiles/FormatName';

const Packages = () => {
    const [search, setSearch] = useState('');
    const [doctorList, setDoctorList] = useState([]);
    const [doctor, setDoctor] = useState({});
    const [searchDoctor, setSearchDoctor] = useState('');
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [editData, setEditData] = useState({});
    const [formData, setFormData] = useState({
        name: '',
        image: '',
        heading: '',
        description: '',
        price: '',
        originalprice: '',
        period: '',
        professionalwebsite: 'no',
        hms: 'no',
        featuredprofile: 'no',
        featureddays: '',
        socialposts: '',
        socialvideos: '',
        autopost: 'no',
        chatsupport: 'no',
        asdoctor: 'no',
        doctor: '',
        sms: '',
        email: '',
        website_pages: '',
        blog: 'no',
        blog_count: '',
        status: 'active',
        patient_count: '',
        whatsup_count: '',
    });

    useEffect(() => {
        getPackages();
    }, []);

    const getPackages = async () => {
        try {
            setLoading(true);
            const tableSchema = '';
            const tableName = 'packages';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = { page: 1, limit: 10 };
            const margedata = [
                {
                    target_table: 'users',
                    target_column: 'id',
                    target_value: 'doctor',
                    target_label: 'doctors'
                }
            ];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.data && response.data.length > 0) {
                // Map legacy field names to the corrected ones for UI consistency
                const normalized = response.data.map(p => ({
                    ...p,
                    originalprice: p.orginalprice,
                    professionalwebsite: p.profesionalwebsite,
                    blog: p.blog,
                    blog_count: p.blog_count,
                }));
                setPackages(normalized);
            } else {
                setPackages([]);
            }
        } catch (error) {
            console.error("Error fetching packages:", error);
            toast.error("Failed to fetch packages");
        } finally {
            setLoading(false);
        }
    }

    const openAdd = () => {
        setFormData({
            name: '',
            image: '',
            heading: '',
            description: '',
            price: '',
            originalprice: '',
            period: '',
            professionalwebsite: 'no',
            hms: 'no',
            featuredprofile: 'no',
            featureddays: '',
            socialposts: '',
            socialvideos: '',
            autopost: 'no',
            chatsupport: 'no',
            asdoctor: 'no',
            doctor: '',
            sms: '',
            email: '',
            website_pages: '',
            blog: 'no',
            blog_count: '',
            status: 'active',
            patient_count: '',
            whatsup_count: '',
        });
        setDoctor({});
        setDoctorList([]);
        setSearchDoctor('');
        setShowAdd(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleimageChange = async (e) => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
        if (!validTypes.includes(file.type)) {
            alert('Please upload a valid image file (JPEG, PNG, or GIF)');
            return;
        }

        const root = 'packages';
        const status = 'public';
        const uploadimage = await OneKlicksFileSDK.uploadFile(root, status, file);
        if (uploadimage && uploadimage.success) {
            setFormData(prev => ({
                ...prev,
                image: uploadimage.file.root + '/' + uploadimage.file.fileName
            }));
        }
    }

    const savePackage = async () => {
        try {
            if (!formData.name) {
                toast.error("Please fill Name");
                return;
            } else if (!formData.heading) {
                toast.error("Please fill Heading");
                return;
            } else if (!formData.description) {
                toast.error("Please fill Description");
                return;
            } else if (!formData.price) {
                toast.error("Please fill Price");
                return;
            } else if (!formData.originalprice) {
                toast.error("Please fill Original Price");
                return;
            } else if (!formData.period) {
                toast.error("Please fill Period");
                return;
            } else if (!formData.whatsup_count) {
                toast.error("Please fill Whatsup Count");
                return;
            } else if (!formData.professionalwebsite) {
                toast.error("Please fill Professional Website");
                return;
            } else if (!formData.hms) {
                toast.error("Please fill HMS");
                return;
            } else if (!formData.featuredprofile) {
                toast.error("Please fill Featured Profile");
                return;
            } else if (formData.featuredprofile === 'yes' && !formData.featureddays) {
                toast.error("Please fill Featured Days count");
                return;
            } else if (formData.blog === 'yes' && !formData.blog_count) {
                toast.error("Please fill Blog Count");
                return;
            } else if (formData.asdoctor === 'yes' && !formData.doctor) {
                toast.error("Please select a Doctor");
                return;
            } else if (!formData.socialposts) {
                toast.error("Please fill Social Posts");
                return;
            } else if (!formData.socialvideos) {
                toast.error("Please fill Social Videos");
                return;
            } else if (!formData.autopost) {
                toast.error("Please fill Auto Post");
                return;
            } else if (!formData.chatsupport) {
                toast.error("Please fill Chat Support");
                return;
            } else if (!formData.sms) {
                toast.error("Please fill SMS count");
                return;
            } else if (!formData.email) {
                toast.error("Please fill Email count");
                return;
            }
            else if (!formData.patient_count) {
                toast.error("Please fill Patient Count");
                return;
            }
            if (formData.professionalwebsite === 'yes' && !formData.website_pages) {
                toast.error("Please fill Website Pages count");
                return;
            }
            const tableSchema = '';
            const tableName = 'packages';
            let response;
            // Prepare payload with both corrected and legacy field names for compatibility
            const slug = formData.name ? formData.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '') : '';
            const payload = {
                ...formData,
                blog: formData.blog,
                blog_count: formData.blog_count,
                blogcount: formData.blog_count,
                orginalprice: formData.originalprice,
                originalprice: formData.originalprice,
                professionalwebsite: formData.professionalwebsite,
                profesionalwebsite: formData.professionalwebsite,
                doctor: formData.doctor,
                doctor_id: formData.doctor,
                slug: slug,
                autopost: formData.autopost,
                chatsupport: formData.chatsupport,
                sms: formData.sms,
                email: formData.email,
                website_pages: formData.website_pages,
                patient_count: formData.patient_count,
                whatsup_count: formData.whatsup_count,
                featuredprofile: formData.featuredprofile,
                featureddays: formData.featureddays,
                socialposts: formData.socialposts,
                socialvideos: formData.socialvideos,
                price: formData.price,
                period: formData.period,
                hms: formData.hms,
                status: formData.status,
            };
            console.log('Payload being sent:', payload);
            if (editData.id) {
                const data = { ...payload };
                delete data.updated_at;
                delete data.created_at;
                delete data.id;
                delete data.target_label;
                delete data.doctors;
                const conditions = { id: editData.id };
                response = await oneKlicks.update(tableSchema, tableName, data, conditions);
            } else {
                const data = payload;
                const conditions = {};
                response = await oneKlicks.create(tableSchema, tableName, data, conditions);
            }
            if (response.success) {
                toast.success("Package saved successfully");
                setShowAdd(false);
                setEditData({});
                getPackages();
            } else {
                console.log('Save response error:', response);
                toast.error("Failed to save package");
            }
        } catch (error) {
            console.error("Error saving package:", error);
            toast.error("Failed to save package");
        }
    }

    useEffect(() => {
        getDoctors();
    }, [formData.asdoctor]);

    const getDoctors = async (name = '') => {
        try {
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'doctor'
            };
            const orderBy = 'id DESC';
            const search = {
                ...(name ? { display_name: name } : {}),
                ...(name ? { email: name } : {}),
                ...(name ? { phone: name } : {})
            };
            const pagination = { page: 1, limit: 10 };
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                setDoctorList(response.data);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
            toast.error("Failed to fetch doctors");
        }
    }

    const handleDoctorChange = (value) => {
        setDoctor({});
        setDoctorList([]);
        setSearchDoctor(value);
        getDoctors(value);
    }

    const handleDoctorSelect = (d) => {
        setDoctor(d);
        setDoctorList([]);
        setSearchDoctor(formatDoctorName(d.display_name));
        setFormData(prev => ({
            ...prev,
            doctor: d.id
        }));
    }

    const handleEdit = (p) => {
        setDoctor({});
        setDoctorList([]);
        setSearchDoctor('');
        setShowAdd(true);
        setEditData(p);
        setFormData(p);
    }

    const handleDelete = async (id) => {
        try {
            const tableSchema = '';
            const tableName = 'packages';
            const conditions = { id: id };
            const response = await oneKlicks.delete(tableSchema, tableName, conditions);
            if (response.success) {
                toast.success("Package deleted successfully");
                getPackages();
            } else {
                toast.error("Failed to delete package");
            }
        } catch (error) {
            console.error("Error deleting package:", error);
            toast.error("Failed to delete package");
        }
    }


    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2  mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Packages</h5>
                                <Badge bg="info">Management</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <InputGroup className="p-0" style={{ maxWidth: 400, flex: "1 1 auto" }}>
                                    <Form.Control
                                        placeholder="Search..."
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                    />
                                </InputGroup>
                                <Button variant="primary" style={{ height: 40, width: 150 }} onClick={openAdd}>+ Add Package</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table hover size="sm" className="mb-0 align-middle">
                                <thead>
                                    <tr>
                                        <th className="text-uppercase">ID</th>
                                        <th className="text-uppercase">Package Name</th>
                                        <th className="text-uppercase">Package Image</th>
                                        <th className="text-uppercase">As Doctor</th>
                                        <th className="text-uppercase" style={{ minWidth: 200 }}>Package Description</th>
                                        <th className="text-uppercase">Package Price</th>
                                        <th className="text-uppercase">SMS</th>
                                        <th className="text-uppercase">Email</th>
                                        <th className="text-uppercase">WhatsApp</th>
                                        <th className="text-uppercase">Web Pages</th>
                                        <th className="text-uppercase">Package Period</th>
                                        <th className="text-uppercase">Package Status</th>
                                        <th className="text-uppercase">Patient Count</th>

                                        <th className="text-uppercase">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr>
                                            <td colSpan={13} className="text-center text-muted py-4">Loading...</td>
                                        </tr>
                                    )}
                                    {!loading && packages.length === 0 && (
                                        <tr>
                                            <td colSpan={13} className="text-center text-muted py-4">No packages found.</td>
                                        </tr>
                                    )}
                                    {packages.map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.id}</td>
                                            <td>{p.name}</td>
                                            <td><ImageShow url={p.image} width={50} height={50} /></td>
                                            <td>
                                                {p.asdoctor === "yes" ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <ImageShow url={p.doctors[0].profile_photo_url} width={50} height={50} />
                                                        <span>{formatDoctorName(p.doctors[0].display_name)}</span>
                                                    </div>
                                                ) : (
                                                    '-'
                                                )}
                                            </td>
                                            <td style={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.description}</td>
                                            <td>{p.price}</td>
                                            <td>{p.sms}</td>
                                            <td>{p.email}</td>
                                            <td>{p.whatsup_count}</td>
                                            <td>{p.website_pages || '-'}</td>
                                            <td>{p.period}</td>
                                            <td>
                                                <Badge bg={p.status === 'active' ? 'success' : 'danger'}>
                                                    {p.status}
                                                </Badge>
                                            </td>
                                            <td>{p.patient_count || '0'}</td>
                                            <td>
                                                <div className="d-flex gap-2">
                                                    <Button size="sm" variant="outline-primary" onClick={() => handleEdit(p)}>Edit</Button>
                                                    <Button size="sm" variant="outline-danger" onClick={() => handleDelete(p.id)}>Delete</Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showAdd} onHide={() => setShowAdd(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{editData.id ? "Edit Package" : "Add Package"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="packageName">
                            <Form.Label>Package Name</Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleInputChange}
                                placeholder="Enter package name"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageImage">
                            <Form.Label>Package Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                onChange={handleimageChange}
                                accept="image/jpeg,image/jpg,image/png,image/gif"
                            />
                        </Form.Group>
                        {formData.image && (
                            <Form.Group controlId="packageImagePreview">
                                <Form.Label>Image Preview</Form.Label>
                                <div className="mt-2">
                                    <ImageShow url={formData.image} width={100} height={100} />
                                </div>
                            </Form.Group>
                        )}
                        <Form.Group controlId="packageHeading">
                            <Form.Label>Package Heading</Form.Label>
                            <Form.Control
                                type="text"
                                name="heading"
                                value={formData.heading}
                                onChange={handleInputChange}
                                placeholder="Enter package heading"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageDescription">
                            <Form.Label>Package Description</Form.Label>
                            <Form.Control
                                type="text"
                                name="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                placeholder="Enter package description"
                            />
                        </Form.Group>
                        <Form.Group controlId="packagePrice">
                            <Form.Label>Package Price</Form.Label>
                            <Form.Control
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleInputChange}
                                placeholder="Enter package price in INR"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageoriginalprice">
                            <Form.Label>Package Original Price</Form.Label>
                            <Form.Control
                                type="number"
                                name="originalprice"
                                value={formData.originalprice}
                                onChange={handleInputChange}
                                placeholder="Enter package original price in INR"
                            />
                        </Form.Group>
                        <Form.Group controlId="packagePeriod">
                            <Form.Label>Package Period</Form.Label>
                            <Form.Control
                                type="number"
                                name="period"
                                value={formData.period}
                                onChange={handleInputChange}
                                placeholder="Enter package period in days"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageprofessionalwebsite">
                            <Form.Label>Package Professional Website</Form.Label>
                            <Form.Select
                                name="professionalwebsite"
                                style={{ width: '100% !important' }}
                                value={formData.professionalwebsite}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        {formData.professionalwebsite === 'yes' && (
                            <Form.Group controlId="packageWebsitePages">
                                <Form.Label>Website Pages Count</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="website_pages"
                                    value={formData.website_pages}
                                    onChange={handleInputChange}
                                    placeholder="Enter number of pages for website"
                                />
                            </Form.Group>
                        )}
                        <Form.Group controlId="packagehms">
                            <Form.Label>Package HMS</Form.Label>
                            <Form.Select
                                name="hms"
                                value={formData.hms}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                                style={{ width: '100% !important' }}
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="packagefeaturedprofile">
                            <Form.Label>Package Featured Profile</Form.Label>
                            <Form.Select
                                name="featuredprofile"
                                value={formData.featuredprofile}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                                style={{ width: '100% !important' }}
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="packageblog">
                            <Form.Label>Package Blog</Form.Label>
                            <Form.Select
                                name="blog"
                                value={formData.blog}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                                style={{ width: '100% !important' }}
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        {formData.blog === "yes" && (
                            <Form.Group controlId="packageblogcount">
                                <Form.Label>Blog Count</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="blog_count"
                                    value={formData.blog_count}
                                    onChange={handleInputChange}
                                    placeholder="Enter number of blog posts"
                                />
                            </Form.Group>
                        )}
                        {formData.featuredprofile === "yes" && (
                            <Form.Group controlId="packagefeatureddays">
                                <Form.Label>Package Featured Days</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="featureddays"

                                    value={formData.featureddays}
                                    onChange={handleInputChange}
                                    placeholder="Enter package featured days"
                                />
                            </Form.Group>
                        )}
                        <Form.Group controlId="packagesocialposts">
                            <Form.Label>Social Posts</Form.Label>
                            <Form.Control
                                type="number"
                                name="socialposts"
                                value={formData.socialposts}
                                onChange={handleInputChange}
                                placeholder="Enter package social posts"
                            />
                        </Form.Group>
                        <Form.Group controlId="packagesocialvideos">
                            <Form.Label>Social Videos</Form.Label>
                            <Form.Control
                                type="number"
                                name="socialvideos"
                                value={formData.socialvideos}
                                onChange={handleInputChange}
                                placeholder="Enter package social videos"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageautopost">
                            <Form.Label>Auto Post</Form.Label>
                            <Form.Select
                                name="autopost"
                                value={formData.autopost}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                                style={{ width: '100% !important' }}
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="packagechatsupport">
                            <Form.Label>Chat Support</Form.Label>
                            <Form.Select
                                name="chatsupport"
                                value={formData.chatsupport}
                                onChange={handleInputChange}
                                className='form-control wl-100'
                                style={{ width: '100% !important' }}
                            >
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId="packageSMS">
                            <Form.Label>SMS Count</Form.Label>
                            <Form.Control
                                type="number"
                                name="sms"
                                value={formData.sms}
                                onChange={handleInputChange}
                                placeholder="Enter SMS count"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageWhatsApp">
                            <Form.Label>WhatsApp Count</Form.Label>
                            <Form.Control
                                type="number"
                                name="whatsup_count"
                                value={formData.whatsup_count}
                                onChange={handleInputChange}
                                placeholder="Enter WhatsApp count"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageEmail">
                            <Form.Label>Email Count</Form.Label>
                            <Form.Control
                                type="number"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                placeholder="Enter email count"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageasdoctor">
                            <Form.Label>Package as Doctor</Form.Label>
                            <Form.Select name="asdoctor" value={formData.asdoctor} onChange={handleInputChange} className='form-control wl-100' style={{ width: '100% !important' }}>
                                <option value="no">No</option>
                                <option value="yes">Yes</option>
                            </Form.Select>
                        </Form.Group>
                        {formData.asdoctor === "yes" && (
                            <Form.Group controlId="packagecategory">
                                <Form.Label>Doctor</Form.Label>
                                <Form.Control type="text" placeholder="Enter doctor" value={searchDoctor || formatDoctorName(doctor.display_name || '')} onChange={(e) => handleDoctorChange(e.target.value)} />
                                {doctorList && doctorList.length > 0 && (
                                    <div className="border rounded mt-2" style={{ maxHeight: 240, overflowY: 'auto' }}>
                                        {doctorList.map((d) => (
                                            <button key={d.id} type="button" className="dropdown-item d-flex align-items-center" onClick={() => handleDoctorSelect(d)} style={{ width: '100%', textAlign: 'left', paddingLeft: 2 }}>
                                                <ImageShow url={d.profile_photo_url} height={40} width={40} style={{ borderRadius: '50%' }} />
                                                <div className="d-flex flex-column ms-2 ml-2" style={{ borderBottom: '1px solid #0000001f' }}>
                                                    <div className="doctor-name" style={{ fontWeight: 'bold', fontSize: 14, marginBottom: -7 }}>{formatDoctorName(d.display_name)}</div>
                                                    <div className="doctor-address text-muted" style={{ fontSize: 10 }}>
                                                        {d.address}
                                                    </div>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </Form.Group>
                        )}
                        <Form.Group controlId="packagePatientCount">
                            <Form.Label>Patient Count</Form.Label>
                            <Form.Control
                                type="number"
                                name="patient_count"
                                value={formData.patient_count}
                                onChange={handleInputChange}
                                placeholder="Enter patient count"
                            />
                        </Form.Group>
                        <Form.Group controlId="packageStatus">
                            <Form.Label>Package Status</Form.Label>
                            <Form.Select
                                name="status"
                                style={{ width: '100% !important' }}
                                className='form-control wl-100'
                                value={formData.status}
                                onChange={handleInputChange}
                            >
                                <option value="active">Active</option>
                                <option value="inactive">Inactive</option>
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowAdd(false)}>Close</Button>
                    <Button variant="primary" onClick={() => savePackage()}>{editData.id ? "Update" : "Save"}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Packages;
